// extracted by mini-css-extract-plugin
var _1 = "EditBuildingAndCategoryFormModal-modulecontent__dBJbt";
var _2 = "EditBuildingAndCategoryFormModal-modulecontentWrapper__QKBQn Content-modulecontentWrapper__p1AMw";
export { _1 as "content", _2 as "contentWrapper" }
